<template>
<div class="menu__container">
   <span :class="barsClass" @click="toggleMenu">
      <span class='bar'></span>
      <span class='bar'></span>
      <span class='bar'></span>
   </span>
   <nav :class="navClass">
      <slot></slot>
   </nav>
</div>
</template>

<script>
export default {
   data() {
      return {
         open: false,
         closing: false,
         close: true,
         barsClosing: false,
         barsClose: true
      }
   },
   props: {
      position: { type: String, default: 'left' },
   },
   mounted() {
      window.addEventListener('click', (e) => {
         let cL = e.target.classList
         if( this.open && !cL.contains('bars') && !cL.contains('bar')) {
            this.toggleMenu()
         }
      })

      window.addEventListener("keydown", (e) => {
         const { key } = e
         if (this.open && key === "Escape") {
            this.toggleMenu()
         }
      });
   },
   methods: {
      toggleMenu() {
         this.closing = this.open == true ? true : false
         this.barsClosing = this.open == true ? true : false
         this.open = !this.open
         
         this.closing == true ?
         setTimeout(() => {
            this.close = true
            this.closing = false
         }, 100) 
         : this.close = !this.close

         this.barsClosing == true ?
         setTimeout(() => {
            this.barsClose = true
            this.barsClosing = false
         }, 300) 
         : this.barsClose = !this.barsClose
      }
   },
   computed: {
      navClass() {
         const { open, closing, close, position } = this
         return [
            open ? 'open' : null,
            closing ? 'closing' : null,
            close ? 'close' : null,
            position == 'right' ? 'right' : null,
            'nav'
         ]
      },
      barsClass() {
         const { open, barsClosing, barsClose } = this
         return [
            open ? 'open' : null,
            barsClosing ? 'closing' : null,
            barsClose ? 'close' : null,
            'bars'
         ]
      }
   }
}
</script>

<style lang='scss' scoped>
@import '~/assets/SCSS/Base/00_functions.scss';
@import '~/assets/SCSS/Base/01_variables.scss';
@import '~/assets/SCSS/Base/02_mixins.scss';

@import '~/assets/SCSS/Menus/burger.scss';
</style>